import { createReducer } from 'redux-act';
import update from 'immutability-helper';

import { set_system_settings } from '../actions';

const DEFAULT_STATE = {
    data: {},
    loading: false,
    error: null
};

export default createReducer({
    [set_system_settings]: 
        (state, payload) => update(state, { 
            data: { $set: payload },
            loading: { $set: false },
            error: { $set: null }
        }),
}, DEFAULT_STATE); 